// extracted by mini-css-extract-plugin
export default {"card":"WY-z","carouselContainer":"XY-z","carouselContent":"YY-z"};